import AuthTokenRepository from "data-access/repository/auth/AuthTokenRepository";
import { IAuthTokenRepository } from "./repository/IAuthTokenRepository";
import { IThirdPartyTokenRepository } from "./repository/IThirdPartyTokenRepository";
import ThirdPartyTokenRepository from "data-access/repository/auth/ThirdPartyTokenRepository";
import { IUserRepository } from "./repository/IUserRepository";
import UserRepository from "data-access/repository/user/UserRepository";
import Factory from "common/utils/Factory";
import { ISettingsRepository } from "./repository/ISettingsRepository";
import SettingsRepository from "data-access/repository/settings/SettingsRepository";

export interface IRepositoryFactory {
    authTokenRepository: IAuthTokenRepository;
    thirdPartyTokenRepository: IThirdPartyTokenRepository;
    userRepository: IUserRepository;
    settingsRepository: ISettingsRepository;
}

// @ts-ignore - avoid breaking the application
export default Factory<IRepositoryFactory>({
    authTokenRepository: () => new AuthTokenRepository(),
    thirdPartyTokenRepository: () => new ThirdPartyTokenRepository(),
    userRepository: () => new UserRepository(),
    settingsRepository: () => new SettingsRepository(),
});
